module.exports = __webpack_public_path__ + "static/media/info.75a7823a.svg";